import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {HttpModule} from '@angular/http';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';

import { TipsComponent } from './tips.component';
import { TipsDetailsComponent } from './tips-details/tips-details.component';
import { TipsService } from './tips.service';

@NgModule({
	imports: [
		BrowserModule,
		CommonModule,
		HttpModule,
		RouterModule,
		SharedModule,
	],
	declarations: [
		TipsComponent,
		TipsDetailsComponent,
	],
	providers: [
		TipsService
	],
})
export class TipsModule {}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/tips/tips.module.ts